
window.loadmorebutton=true;
document.addEventListener('scroll', function () {
    if (document.querySelector('#load-more') != null) {
        const box = document.querySelector('#load-more');
        let visible = isInViewport(box) ? 1 : 0;
        if (visible && window.loadmorebutton) {
            window.loadmorebutton=false;
            box.click();
        }
    }
});

function isInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)

    );
}

if (document.querySelectorAll('[data-tag_filters]').length == document.querySelectorAll('[data-tag_filters].d-none').length) {
    if (document.querySelector('[data-filter-drawer-wrapper]') != null) {
        document.querySelector('[data-filter-drawer-wrapper]').style.display="none";
    }
    if (document.querySelector('[data-mobile-filters]') != null) {
        document.querySelector('[data-mobile-filters]').style.display="none";
    }
    document.querySelectorAll('[data-collection_card]').forEach(ele => {
      ele.classList.remove('col-lg-4');
      ele.classList.add('col-lg-3');
    });
    document.querySelectorAll('[data-collection_promoCard]').forEach(ele => {
      ele.classList.remove('col-lg-4');
      ele.classList.add('col-lg-3');
    });
    document.querySelector('[data-collection-header]').classList.remove('col-lg-9');
}else{
    if (document.querySelector('[data-filter-drawer-wrapper]') != null) {
        document.querySelector('[data-filter-drawer-wrapper]').style.display="";
    }
    if (document.querySelector('[data-mobile-filters]') != null) {
        document.querySelector('[data-mobile-filters]').style.display="";
    }
    document.querySelectorAll('[data-collection_card]').forEach(ele => {
      ele.classList.add('col-lg-4');
      ele.classList.remove('col-lg-3');
    });
    document.querySelectorAll('[data-collection_promoCard]').forEach(ele => {
      ele.classList.add('col-lg-4');
      ele.classList.remove('col-lg-3');
    });
    document.querySelector('[data-collection-header]').classList.add('col-lg-9');
  }